import React from 'react';
import { TooltipBlack } from '../../../components/Tooltip/TooltipBlack/TooltipBlack';
import './AuthorAvatar.scss'

interface AuthorAvatarProps {
    show_name?: boolean
    showTooltip?: boolean
    author: string[]
    size: string
    group?: boolean
    isStatus?: boolean
    status?: boolean

}

const AuthorAvatar: React.FC<AuthorAvatarProps> = ({
    show_name,
    showTooltip = false,
    author,
    size = 's',
    group = false,
    isStatus,
    status
}) => {

    const current_className = size === 's' ? 'author-avatar' : size === 'xs' ? 'author-avatar-xs' : 'author-avatar-m'
    const position_classname = group ? 'author-avatar__wrapper-left' : ''

    const author_icon = () => {
        return <div className={current_className}
            style={{
                background: author?.[1] ? author?.[1] : ''
            }}
        >{author?.[0]?.split(' ')
            .map(str => str[0])
            .reduce((acc, current) => acc += current, '')
            ?.slice(0, 2)
            ?.toUpperCase() || '-'}
            
            {isStatus && <span className={`author-avatar${status ? '__status-green' : '__status-red'}`}></span>}
        </div>
    }

    return (
        <div className={'author-avatar__wrapper' + ' ' + position_classname}
            key={author?.[0] + author?.[1]}
        >
            {showTooltip ?
                <TooltipBlack
                    child={author_icon()}
                    text={author?.[0]}
                />
                :
                author_icon()
            }
            {(show_name && author?.[0]) && <span className='author-avatar__name'>{author?.[0]}</span>}
        </div>
    );
}

export { AuthorAvatar };


